/**
 * ExternalUserExtraNetwork entity class
 */

/**
 * ExternalUserExtraNetworkFactory
 * returns ExternalUserExtraNetwork entity class
 *
 * @class ExternalUserExtraNetworkFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.ExternalUserExtraNetwork} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ExternalUserExtraNetworkFactory
 */
/* @ngInject */
export default function ExternalUserExtraNetworkFactory (Entity) {
  /* === ExternalUserExtraNetwork class === */

  /**
   * ExternalUserExtraNetwork model
   *
   * @class ExternalUserExtraNetwork
   * @classdesc ExternalUserExtraNetwork model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @param {Object} [object] - initial object, containing ExternalUserExtraNetwork entity fields
   * @return {models.ExternalUserExtraNetwork} ExternalUserExtraNetwork entity
   */
  function ExternalUserExtraNetwork () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  ExternalUserExtraNetwork.prototype = Object.create(Entity.prototype)
  ExternalUserExtraNetwork.prototype.constructor = ExternalUserExtraNetwork

  /* === ExternalUserExtraNetwork instance methods & fields === */

  Object.assign(ExternalUserExtraNetwork.prototype, {

    /**
     * instance fields
     *
     * @memberof models.ExternalUserExtraNetwork#
     * @type {Object}
     */
    _fields: {
      id: Number,
      name: String,
      addOns: ['Subscription'],
      subscriptions: ['Subscription']
    }

  })

  /* === ExternalUserExtraNetwork static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(ExternalUserExtraNetwork, Entity)
  ExternalUserExtraNetwork._name = 'ExternalUserExtraNetwork'
  ExternalUserExtraNetwork.init()

  return ExternalUserExtraNetwork
}
